import { render, staticRenderFns } from "./ResponsepageView.vue?vue&type=template&id=88d142ac&scoped=true"
import script from "./ResponsepageView.vue?vue&type=script&lang=js"
export * from "./ResponsepageView.vue?vue&type=script&lang=js"
import style0 from "./ResponsepageView.vue?vue&type=style&index=0&id=88d142ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d142ac",
  null
  
)

export default component.exports